import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAddressCardWrapper = styled(Flexbox)<{$border?: 'left' | 'right'}>(
    ({theme: {typography, palette, spacing}, $border: borderPosition}) => css`
        ${typography.textMd};
        color: ${palette.neutral[600]};
        padding: ${spacing * 2}px;

        ${borderPosition &&
        css`
            border-${borderPosition}: 1px solid ${palette.neutral[200]};
        `}
    `
)

export const StyledAddressCardTitle = styled.h4<{$hasError?: boolean}>(
    ({theme: {palette}, $hasError}) => css`
        color: ${$hasError ? palette.danger[600] : palette.neutral[950]};
        font-weight: 500;
    `
)
export const StyledAddressCardSubtitle = styled.h4(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[950]};
        font-weight: 400;
    `
)
